<template>
  <v-content style="position: relative;" class="tablet">
    <v-snackbar v-model="snackbar" :timeout='2000' top>{{ snackbarMessage }}</v-snackbar>
    <v-flex style="position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
      <v-flex xs12 v-show="frontPage && hasContractorRole">
        <v-btn @click="gotoProduction" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start production
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasCreatePalletRole">
        <v-btn @click="gotoCreatePallet" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Create pallet
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasLoaderRole || hasCarrierRole || hasSupplierRole)">
        <v-btn @click="gotoLoading" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start loading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasLoaderRole || hasCarrierRole || hasSupplierRole)">
        <v-btn @click="gotoUnloading" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start unloading
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasRepackagingRole">
        <v-btn @click="gotoRepackaging" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start repackaging
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasLabellerRole">
        <v-btn @click="gotoLabelling" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Start labelling
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasForecastRole">
        <v-btn @click="gotoForecast" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Forecast
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasStockListRole">
        <v-btn @click="gotoStockList" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Stock list
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasTimeRegistrationRole">
        <v-btn @click="gotoTimeRegistration" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Time registration
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && (hasContractorRole || hasSupplierRole)">
        <v-btn @click="gotoProductionReport" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Production report
        </v-btn>
      </v-flex>
      <v-flex xs12 v-show="frontPage && hasSupplierRole">
        <v-btn @click="gotoSupplierData" :style="'height: ' + Math.min(60 / numberOfFrontPageButtons, 30) + 'vh !important; width: 50vw; font-size: ' + (40 - (3 * numberOfFrontPageButtons)) + 'pt !important; margin-bottom: 2vh;'">
          Supplier data
        </v-btn>
      </v-flex>
    </v-flex>

    <TodoProduction v-if="productionVisible"/>
    <TodoCreatePallet v-if="createPalletVisible"/>
    <TodoLoading v-if="loadingVisible"/>
    <TodoUnloading v-if="unloadingVisible"/>
    <TodoRepackaging v-if="repackagingVisible"/>
    <TodoLabelling v-if="labellingVisible"/>
    <TodoTimeRegistration v-if="timeRegistrationVisible"/>
    <ProductionReport v-if="productionReportVisible"/>
    <SupplierData v-if="supplierDataVisible"/>
    <Forecast :edit-category-families="hasForecastRole" v-if="forecastVisible"/>
    <StockList v-if="stockListVisible"/>
  </v-content>
</template>

<script>
import Panel from '../components/Panel'
import TodoProduction from './TodoProduction'
import TodoCreatePallet from './TodoCreatePallet'
import TodoLabelling from './TodoLabelling'
import TodoLoading from './TodoLoading'
import TodoUnloading from './TodoUnloading'
import TodoRepackaging from './TodoRepackaging'
import TodoTimeRegistration from './TodoTimeRegistration'
import ProductionReport from './ProductionReport'
import Forecast from './Forecast'
import StockList from './StockList'
import SupplierData from './SupplierData.vue'

export default {
  name: 'Content',
  components: { Panel, TodoProduction, TodoCreatePallet, TodoLabelling, TodoLoading, TodoUnloading, TodoRepackaging, ProductionReport, Forecast, StockList, SupplierData, TodoTimeRegistration },
  data () {
    return {
      frontPage: true,
      productionVisible: false,
      createPalletVisible: false,
      loadingVisible: false,
      unloadingVisible: false,
      repackagingVisible: false,
      labellingVisible: false,
      forecastVisible: false,
      stockListVisible: false,
      timeRegistrationVisible: false,
      productionReportVisible: false,
      supplierDataVisible: false,
      snackbar: false,
      snackbarMessage: ''
    }
  },
  created: function () {
  },
  computed: {
    fullName: function () {
      return this.$store.state.session.fullName
    },
    roles: function () {
      return this.$store.state.session.roles
    },
    hasContractorRole: function () {
      return this.$store.getters['session/hasRole']('CONTRACTOR') && !this.hasTimeRegistrationRole
    },
    hasCreatePalletRole: function () {
      return this.$store.getters['session/hasRole']('CREATE_PALLET') && !this.hasTimeRegistrationRole
    },
    hasCustomerRole: function () {
      return this.$store.getters['session/hasRole']('CUSTOMER') && !this.hasTimeRegistrationRole
    },
    hasLoaderRole: function () {
      return this.$store.getters['session/hasRole']('LOADER') && !this.hasTimeRegistrationRole
    },
    hasSupplierRole: function () {
      return this.$store.getters['session/hasRole']('SUPPLIER') && !this.hasTimeRegistrationRole
    },
    hasCarrierRole: function () {
      return this.$store.getters['session/hasRole']('CARRIER') && !this.hasTimeRegistrationRole
    },
    hasRepackagingRole: function () {
      return this.$store.getters['session/hasRole']('REPACKAGING') && !this.hasTimeRegistrationRole
    },
    hasLabellerRole: function () {
      return this.$store.getters['session/hasRole']('LABELLER') && !this.hasTimeRegistrationRole
    },
    hasStockListRole: function () {
      return this.$store.getters['session/hasRole']('STOCK_LIST') && !this.hasTimeRegistrationRole
    },
    hasForecastRole: function () {
      return this.$store.getters['session/hasRole']('FORECAST') && !this.hasTimeRegistrationRole
    },
    hasTimeRegistrationRole: function () {
      return this.$store.getters['session/hasRole']('TIME_REGISTRATION')
    },
    numberOfFrontPageButtons: function () {
      let number = 0
      if (this.hasContractorRole) {
        number++
      }
      if (this.hasCreatePalletRole) {
        number++
      }
      if (this.hasContractorRole || this.hasLoaderRole || this.hasCarrierRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasContractorRole || this.hasLoaderRole || this.hasCarrierRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasContractorRole || this.hasSupplierRole) {
        number++
      }
      if (this.hasSupplierRole) {
        number++
      }
      if (this.hasRepackagingRole) {
        number++
      }
      if (this.hasLabellerRole) {
        number++
      }
      if (this.hasForecastRole) {
        number++
      }
      if (this.hasStockListRole) {
        number++
      }
      if (this.hasTimeRegistrationRole) {
        number++
      }
      return number
    }
  },
  methods: {
    showMessage (message) {
      this.snackbarMessage = message
      this.snackbar = true
    },
    gotoHome: function () {
      this.frontPage = true
      this.productionVisible = false
      this.createPalletVisible = false
      this.loadingVisible = false
      this.unloadingVisible = false
      this.repackagingVisible = false
      this.labellingVisible = false
      this.forecastVisible = false
      this.stockListVisible = false
      this.timeRegistrationVisible = false
      this.productionReportVisible = false
      this.supplierDataVisible = false
    },
    gotoProduction: function () {
      this.frontPage = false
      this.productionVisible = true
    },
    gotoCreatePallet: function () {
      this.frontPage = false
      this.createPalletVisible = true
    },
    gotoLoading: function () {
      this.frontPage = false
      this.loadingVisible = true
    },
    gotoUnloading: function () {
      this.frontPage = false
      this.unloadingVisible = true
    },
    gotoRepackaging: function () {
      this.frontPage = false
      this.repackagingVisible = true
    },
    gotoLabelling: function () {
      this.frontPage = false
      this.labellingVisible = true
    },
    gotoForecast: function () {
      this.frontPage = false
      this.forecastVisible = true
    },
    gotoStockList: function () {
      this.frontPage = false
      this.stockListVisible = true
    },
    gotoTimeRegistration: function () {
      this.frontPage = false
      this.timeRegistrationVisible = true
    },
    gotoProductionReport: function () {
      this.frontPage = false
      this.productionReportVisible = true
    },
    gotoSupplierData: function () {
      this.frontPage = false
      this.supplierDataVisible = true
    },
    loadContractorPallets: function () {
      this.$store.dispatch('contractor/loadPallets')
    }
  }
}
</script>

<style>
  @import '../assets/css/tablet.css';
</style>



// WEBPACK FOOTER //
// src/components/Todo.vue